import { connect, MapStateToProps } from 'react-redux';
import { Url } from '@wix/da-url';
import { AppState } from '../../../../types/store';
import {
  getProfileOwnerUser,
  getProfileOwnerStats,
  getProfileOwnerTagline,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { getModuleIdByModuleType } from '../../../selectors/modules';
import { Props } from './ProfileIdentity';
import { ModuleType } from '../../../../types/modules';

export type StateProps = Pick<
  Props,
  | 'profileOwnerUser'
  | 'tagline'
  | 'url'
  | 'stats'
  | 'aboutModuleId'
  | 'isCurrentUserProfileOwner'
>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const profileOwnerUser = getProfileOwnerUser(state);
  return {
    profileOwnerUser,
    tagline: getProfileOwnerTagline(state) || '',
    stats: getProfileOwnerStats(state),
    isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
    url: Url.userLink(profileOwnerUser.username),
    aboutModuleId: getModuleIdByModuleType(state, ModuleType.ABOUT),
  };
};

export default connect(mapStateToProps);
